import React, { Component } from "react";
import NavigationChange from "../../components/NavigationChange";
import { Form } from "react-bootstrap";
import TaskCreate from "../../screens/TaskPackages/TaskCreate.jsx";
import TaskGrid from "./TaskGrid";
import Pagination from "@mui/material/Pagination";
import AuthService from "../../session/AuthService";
import ManageUserService from "../../api/ManageUserService";
import TaskApi from "../../api/TaskApi";
import IconButton from "@mui/material/IconButton";
import TuneIcon from "../../Icons/TuneIcon";
import FilterModal from "./FilterModal";
import { Toaster, toast } from "react-hot-toast";
import { FiXCircle } from "react-icons/fi";
import { connect } from "react-redux";
import { getExpiredDate } from "../../redux/actions/MangeUserProfileAction.js";
import CreateServiceRecord from "../ServiceRecordPackage/CreateServiceRecord.jsx";
import BuildingsApi from "../../api/BuildingsApi.js";


let categoryData = [{id : 1 , name : "Building"} ,{id : 2 , name : "Equipment"} ,{id : 3 , name : "Vehicle"} , {id : 4 , name : "None"}];

let statusData = [{id : 1 , name : "Pending"} ,{id : 2 , name : "Complete"} ];

class TaskContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      taskList: [],
      totalCount: 0,
      totalPageno: 0,
      openModal: false,
      changeStateforEdit: false,
      pageNo: 0,
      search: "",
      currentPage: 1,
      openFilterModal: false,
      commonFilterArray: [],
      filterValue: "Pending",
      filterType: "",
      activeServiceRecord : false, 
      type : 0,
      resourseValue:  0,
      taskId : 0,
      openCompleteButton : false,
      commonArrays : [],
      colorChange3 : true,
      colorChange2 : true,
      filterby :  "Status",
      

    };
  }

  componentDidMount = () => {
    this.togetEmployeeData();
    this.togetAllTaskdata();
    this.getStatus();
     
     toast.dismiss();
  };


 

  togetEmployeeData = () => {
    let obj = { group_id: parseInt(AuthService.getUserId()) };

    ManageUserService.getAllUserData(obj).then((response) => {
      console.log("response in userData", response);
      if (response.data && response.data.data) {
        this.setState({
          userList: response.data.data.UserData,
        });
      }
    });
  };

  togetAllTaskdata = () => {

    this.setState({
      pageNo: 0,
      search: "",
      filterValue: this.state.filterValue,
      currentPage: 1
    },() =>{
      let obj = {
        group_id: parseInt(AuthService.getUserId()),
        pageNo: this.state.pageNo,
        search: "",
        filterValue: this.state.filterValue,
      };
  
      TaskApi.getTask(obj).then((response) => {
        console.log(response, "Task");
        if (response.data && response.data.data) {
          this.setState({
            taskList: response.data.data.taskList,
            totalCount: response.data.data.totalCount,
            totalPageno: response.data.data.totalPageno,
          });
        }
      });
    })
   
  };

  render() {
    return (
      <>
        <div className="Heading" style={{ paddingTop: "15px" }}>
          <NavigationChange
            Topics={"Tasks"}
            numberofRecord={this.state.totalCount}
            specficwidth={"94"}
            back={true}
          />
        </div>
        <div className="container-of-createButton" id="titleWithDropdowns">
          <div className="search-contain">
            <Form.Label style={{ fontSize: "17px" }}>Search</Form.Label>

            <div class="search">
              <span class="fa fa-search" onClick={this.search}></span>
              <input
                type="text"
                placeholder="Type Here..."
                name="search"
                value={this.state.search}
                onKeyPress={this.handleKeyPress}
                onChange={this.searchvalue}
              />
            </div>
          </div>

          <div className="filter-by-container">
            <span style={{ fontSize: "17px" }}>{"Filter "}</span>
            {this.state.filterType !== "" && (
              <Form.Label style={{ fontSize: "17px" }}>
                {"By "}
                {this.state.filterType}
              </Form.Label>
            )}

            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <IconButton
                aria-label="filter"
                onClick={this.handleFilterClick}
                size="medium"
                sx={{ mr: 1, backgroundColor: "#d9d9d9" }}
              >
                <TuneIcon className="custom-icon" />
              </IconButton>
            </div>
          </div>
          <div className="clear-filter-container">
            {this.state.filterType !== "" && (
              <>
                <Form.Label style={{ fontSize: "17px" }}>
                  Clear Filter{" "}
                </Form.Label>

                <div
                  onClick={this.clearfilter}
                  style={{ paddingTop: "5px", paddingLeft: "20px" }}
                >
                  <FiXCircle style={{ fontSize: "25px" }} />
                </div>
              </>
            )}
          </div>
          <div className="create-button">
          {AuthService.getUserTypeAdmin() !== "3" && (
           <>
            <div className="button-end">
              <button
                className="btn btn-success"
                onClick={this.OpenCreateTask}
                style={{
                  backgroundColor: "#8ABC49",
                  borderColor: "#8ABC49",
                  padding: "4px",
                  width: "10rem",
                }}
              >
                Create Task
              </button>
            </div>
           </>
          )}

           
          </div>
        </div>
        <TaskGrid
          taskList={this.state.taskList}
          onLoad={this.togetAllTaskdata}
          ActiveEdit={(a) => this.activeEdit(a)}
          userList={this.state.userList}
          renderToast={(a) => this.renderToast(a)}
          completeTaskOnLoad={this.completeTaskOnLoad}
          errorToast={(a) => this.errorToast(a)}
          openService={(e)=>this.openServiceRecord(e)}
          openCompleteButton={this.state.openCompleteButton}
          openCompleteButtonMethod={this.closeCompleteButton}
        
          
        />

        <div className="mt-3" style={{ width: "99%", margin: "0 auto" }}>
          <div className="d-flex justify-content-center">
            <Pagination
              count={this.state.totalPageno}
              onChange={(event, value) => this.handlePageChange(value)}
              page={this.state.currentPage}
            />
          </div>
        </div>

        {this.state.openModal && (
          <TaskCreate
            handleClose={this.closeHandleclose}
            show={this.state.openModal}
            userList={this.state.userList}
            option={!this.state.changeStateforEdit ? "new" : "edit"}
            editValue={this.state.editValue}
            onLoad={this.togetAllTaskdata}
            renderToast={(a) => this.renderToast(a)}
            completeTaskOnLoad={this.completeTaskOnLoad}
            errorToast={(a) => this.errorToast(a)}
          />
        )}

        {this.state.openFilterModal && (
          <FilterModal
            show={this.state.openFilterModal}
            handleClose={this.closeFilterModal}
            filterdata={(e) => this.getfilterValue(e)}
            clearfilter={this.clearfilter}
            getFilterType={(a) => this.getfilterType(a)}
           
            onFilterByChange={(e) => this.onFilterByChange(e)}
            onFilterByChangeValue={(e) => this.onFilterByChangeValue(e)}
            filterValue={this.state.filterValue}
            filterby={this.state.filterby}
            commonFilterArray={this.state.commonFilterArray}
            colorChange3={this.state.colorChange3}

          />
        )}

           {this.state.activeServiceRecord && (
             <>
                <CreateServiceRecord
                 show={this.state.activeServiceRecord}
                 handleClose={this.cloeServiceRecord}
                 option={"new"}
                 userList={this.state.userList}
                 comefrom={"task"}
                 Type={this.state.type}
                 service_resourceId={this.state.resourseValue}
                 renderToast={(e) => this.renderToast2(e)}
                 taskId={this.state.taskId}
                 openCompleteButton={this.openCompleteButton}
                 commonArrays={this.state.commonArrays}
                 

                  


                /> 
             </>
           )}
        
        <Toaster />
      </>
    );
  }

  

  onFilterByChangeValue = (event) => {
    
    
    console.log("even in filter value" , event)

      this.setState({
        filterValue : event.target.value,
        colorChange3 : true
      })
  }



  onFilterByChange = (event) => {
    this.setState(
      {
        [event.target.name]: event.target.value,
        colorChange2 : true,
        filterType : event.target.value

      },
      () => {
        if (this.state.filterby === "Category") {
          this.getCategory();
          
        } else if (this.state.filterby === "Status") {
          this.getStatus();
         
        } else if (this.state.filterby === "Employee") {
          this.togetEmployeeFilter();
          
        } else {
         
        }
      }
    );
  };



  getCategory = () => {
    this.setState({
      commonFilterArray: categoryData,
      filterValue : "Building"
    });
  };

  getStatus = () => {
    this.setState({
      commonFilterArray: statusData,
      filterValue : "Pending"
    });
  };

  togetEmployeeFilter = () => {
    let obj = { group_id: parseInt(AuthService.getUserId()) };

    ManageUserService.getAllUserData(obj).then((response) => {
      console.log("response in userData", response);
      if (response.data && response.data.data) {
        this.setState({
          commonFilterArray: response.data.data.UserData,
          filterValue : 0
        },() => {
            console.log("userData" , this.state.commonFilterArray)
        });
      }
    });
  };




  closeCompleteButton = () => {
    this.setState({
      openCompleteButton : false
    })
  }

  openCompleteButton = () => {
    this.setState({
      openCompleteButton : true
    })
  }

  renderToast2 = (status) => {
    toast.success(`Service Record  ${status} Successfully`);
    
  };


  renderToast = (status) => {
    toast.success(`Service Record ${status} Successfully`);
  };

  cloeServiceRecord = () => {

    console.log("this.statet.editvalues" , this.state.editValue)
    this.setState({
      activeServiceRecord : false
   
    })
  }


  openServiceRecord = (editValue) => {

    console.log("this.statet.editvalues" , editValue)
    this.setState({
      activeServiceRecord : true,
      editValue:  editValue,
      type : editValue.resourseType,
      resourseValue : editValue.resourseValue,
      taskId : editValue.taskId

    },()=> {
         console.log("this.saytetetet" , this.state)
        if (editValue.resourseType === 1) {
          this.togetBuildingdata();
        } else if (editValue.resourseType === 2) {
          this.togetEquipmentdata();
        } else if (editValue.resourseType  === 3) {
          this.togetvechileData();
        } else {
        }
    
    })
  }



  clearfilter = () => {
 
    this.setState(
      {
        group_id: parseInt(AuthService.getUserId()),
        pageNo: 0,
        search: "",
        filterValue: "Pending",
        filterType: "",
        filterby : "Status"
      },
      () => {
        console.log("check state value" , this.state)
        let obj = {
          group_id: parseInt(AuthService.getUserId()),
          pageNo: 0,
          search: "",
          filterValue: this.state.filterValue,
        };
        TaskApi.getTask(obj).then((response) => {
          console.log(response, "Task");
          if (response.data && response.data.data) {
            this.setState({
              taskList: response.data.data.taskList,
              totalCount: response.data.data.totalCount,
              totalPageno: response.data.data.totalPageno,
              openFilterModal: false,
            });
          }
        });
      }
    );
  };

  getfilterValue = (e) => {
    console.log("e in parent page", e);

    this.setState(
      {
        filterValue: e,
      },
      () => {
        let obj = {
          group_id: parseInt(AuthService.getUserId()),
          pageNo: 0,
          search: this.state.search,
          filterValue: this.state.filterValue,
        };
        TaskApi.getTask(obj).then((response) => {
          console.log(response, "Task");
          if (response.data && response.data.data) {
            this.setState({
              taskList: response.data.data.taskList,
              totalCount: response.data.data.totalCount,
              totalPageno: response.data.data.totalPageno,
            });
          }
        });
      }
    );
  };

  handleFilterClick = () => {
    this.setState({
      openFilterModal: true,
      filterValue : this.state.filterValue,
      filterby : this.state.filterby


      
    },() => {
      if(this.state.filterby === "Status"){
        this.setState({
          commonFilterArray: statusData,
        })
      }
    });
  };

  closeFilterModal = () => {
    this.setState({
      openFilterModal: false,
   
    });
  };

 

  searchvalue = (event) => {
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
        if (event.target.value.length === 0) {
          this.search();
        }
      }
    );
  };

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.search();
    }
  };

  search = () => {
    let obj = {
      group_id: parseInt(AuthService.getUserId()),
      pageNo: 0,
      search: this.state.search,
      filterValue: this.state.filterValue,
    };

    TaskApi.getTask(obj).then((response) => {
      console.log(response, "Task");
      if (response.data && response.data.data) {
        this.setState({
          taskList: response.data.data.taskList,
          totalCount: response.data.data.totalCount,
          totalPageno: response.data.data.totalPageno,
        });
      }
    });
  };

  activeEdit = (a) => {
    this.setState({
      changeStateforEdit: true,
      editValue: a,
      openModal: true,
    },() => {
      console.log("editValue" , this.state.editValue)
    });
  };

  OpenCreateTask = () => {
    this.setState({
      openModal: true,
      changeStateforEdit: false,
    });
  };

  closeHandleclose = () => {
    this.setState({
      openModal: false,
    });
  };

  handlePageChange = (i) => {
    let page = null;
    if (i === 1) {
      page = 0;
    } else {
      page = i - 1;
    }
    this.setState({ currentPage: i, pageNo: page }, () => {
      let obj = {
        pageNo: this.state.pageNo,
        search: this.state.search,
        group_id: parseInt(AuthService.getUserId()),
        filterValue: this.state.filterValue,
      };
      TaskApi.getTask(obj).then((response) => {
        console.log(response, "Task");
        if (response.data && response.data.data) {
          this.setState({
            taskList: response.data.data.taskList,
            totalCount: response.data.data.totalCount,
            totalPageno: response.data.data.totalPageno,
          });
        }
      });
    });
  };

  completeTaskOnLoad  = () => {
    let obj = {
      pageNo: this.state.pageNo,
      search: "",
      group_id: parseInt(AuthService.getUserId()),
      filterValue: this.state.filterValue,
    };
    TaskApi.getTask(obj).then((response) => {
      console.log(response, "Task");
      if (response.data && response.data.data) {
        this.setState({
          taskList: response.data.data.taskList,
          totalCount: response.data.data.totalCount,
          totalPageno: response.data.data.totalPageno,
        });
      }
    });
  }


  togetBuildingdata = () => {
 
    let obj = {
      group_id: AuthService.getUserId(),
    };

    BuildingsApi.getBuildingData(obj).then((response) => {
      if (response.data && response.data.data) {
        this.setState(
          {
            commonArrays: response.data.data.buildingData,
          },
          () => {
            console.log("this is ", this.state.commonArrays);
          }
        );
      } else {
      }
    });
  };

  togetEquipmentdata = () => {
    let obj = {
      group_id: AuthService.getUserId(),
    };

    BuildingsApi.getEquipmentData(obj).then((response) => {
      if (response.data && response.data.data) {
        this.setState({
          commonArrays: response.data.data.equipmentData,
        });
      } else {
      }
    });
  };

  togetvechileData = () => {
    let obj = {
      group_id: AuthService.getUserId(),
    };

    BuildingsApi.getVehicleData(obj).then((response) => {
      if (response.data && response.data.data) {
        this.setState({
          commonArrays: response.data.data.vehicleData,
        });
      } else {
      }
    });
  };

  renderToast = (status) => {
    toast.success(`Task ${status} Successfully`);
  };

  errorToast = (status) => {
    toast.error(status)
  }
}


const mapStateToProps = function (state) {
  return {

  };
};

const mapDispatchToProps = function (dispatch) {
  return {
   
    getExpiredDate: (data) => dispatch(getExpiredDate(data)),
   

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskContainer);


